export enum ActionType {
  logout = 'logout',
}
